import script from "./activity-notification.vue?vue&type=script&lang=ts&setup=true"
export * from "./activity-notification.vue?vue&type=script&lang=ts&setup=true"

import "./activity-notification.vue?vue&type=style&index=0&id=8533b2c0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8533b2c0"]])

export default __exports__